import { Action } from 'common/actions/appAction';

export const CLEAR_UPLOAD_DATA = 'CLEAR_UPLOAD_DATA';
export type ClearUploadData = Action<typeof CLEAR_UPLOAD_DATA>;
export const clearUploadData = () => ({
    type: CLEAR_UPLOAD_DATA,
});

export type UploadAction = ClearUploadData;
